import React, { useState } from "react";
import * as XLSX from "xlsx";
import "./index.css";

import CountryCodeSelect from "../../helper/input/CountryCodeSelect";

const Marketing = () => {
    const [mode, setMode] = useState("single");
    const [campaign, setCampaign] = useState("");
    const [name, setName] = useState("");
    const [contact, setContact] = useState("");
    const [countryCode, setCountryCode] = useState("91");

    const [excelFile, setExcelFile] = useState(null);
    const [excelCount, setExcelCount] = useState(0);

    const [mediaFile, setMediaFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    // 📌 Validation
    const validate = () => {
        if (!campaign) return "Campaign name is required";

        if (mode === "single") {
            if (!name) return "Name is required";
            if (!/^[0-9]{10}$/.test(contact))
                return "Enter valid 10-digit number";
        }

        if (mode === "bulk" && !excelFile)
            return "Please upload Excel file";

        if (!mediaFile) return "Please upload image or PDF";

        return null;
    };

    // 📌 Excel Parsing
    const handleExcelUpload = (file) => {
        setExcelFile(file);

        const reader = new FileReader();
        reader.onload = (e) => {
            const wb = XLSX.read(e.target.result, { type: "binary" });
            const sheet = wb.Sheets[wb.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(sheet);

            setExcelCount(data.length);
        };
        reader.readAsBinaryString(file);
    };

    // 📌 Media Upload
    const handleMediaUpload = (file) => {
        setMediaFile(file);

        if (file.type.startsWith("image/")) {
            setPreviewUrl(URL.createObjectURL(file));
        } else {
            setPreviewUrl(null);
        }
    };

    // 📌 Submit
    const handleSubmit = async () => {
        const error = validate();
        if (error) {
            setMessage(error);
            return;
        }

        setLoading(true);
        setMessage("");

        try {
            const formData = new FormData();

            formData.append("campaign", campaign);
            formData.append("mode", mode);
            formData.append("media", mediaFile);

            if (mode === "single") {
                formData.append("name", name);
                formData.append("contact", countryCode + contact);
            } else {
                formData.append("file", excelFile);
            }

            // 🔗 Replace with your backend
            await fetch("/api/send-marketing", {
                method: "POST",
                body: formData,
            });

            setMessage("✅ Communication sent successfully");
        } catch (err) {
            setMessage("❌ Failed to send communication");
        }

        setLoading(false);
    };

    return (
        <div className="page-container">
            <div className="header">
                <h2>Marketing</h2>
            </div>

            {/* Campaign */}
            <div className="form-group two-col-row">
                <div>
                <label>Campaign Name</label>
                <input
                    type="text"
                    placeholder="Eg: New Launch Campaign"
                    value={campaign}
                    onChange={(e) => setCampaign(e.target.value)}
                />
                </div>
            </div>

            {/* Toggle */}
            <div className="tabs" role="tablist">
                <div className={`tab ${mode === "single" ? 'active' : ''}`} onClick={() => setMode('single')}>Single User</div>
                <div className={`tab ${mode === 'bulk' ? 'active' : ''}`} onClick={() => setMode('bulk')}>Upload Excel</div>
            </div>

            {/* Single */}
            {mode === "single" && (
                <>
                    <div className="form-group two-col-row">
                        <div>
                        <label className="label-inline">Name</label>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        </div>
                    </div>

                    <div className="form-group display-f">
                        <label className="label-inline">WhatsApp Contact</label>
                        <CountryCodeSelect value={countryCode} onChange={(value) => setCountryCode(value)} />
                        <input className="input" type="tel" name="mobile" pattern="[0-9]{10}" placeholder="XXXXXXXXXX" value={contact} onChange={e => setContact(e.target.value)} />
                    </div>
                </>
            )}

            {/* Bulk */}
            {mode === "bulk" && (
                <div className="form-group">
                    <label className="label-inline">Upload Excel</label>
                    <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={(e) =>
                            handleExcelUpload(e.target.files[0])
                        }
                    />

                    {excelCount > 0 && (
                        <p className="info">
                            📊 {excelCount} contacts found
                        </p>
                    )}
                </div>
            )}

            {/* Media */}
            <div className="form-group">
                <label className="label-inline">Upload Image / PDF</label>
                <input
                    type="file"
                    accept="image/*,application/pdf"
                    onChange={(e) =>
                        handleMediaUpload(e.target.files[0])
                    }
                />
            </div>

            {/* Preview */}
            {previewUrl && (
                <div className="preview">
                    <img src={previewUrl} alt="preview" />
                </div>
            )}

            {!previewUrl && mediaFile?.type === "application/pdf" && (
                <div className="preview">
                    <p>📄 {mediaFile.name}</p>
                </div>
            )}

            {/* Message */}
            {message && <p className="message">{message}</p>}

            {/* Submit */}
            <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={loading}
            >
                {loading ? "Sending..." : "Send Communication"}
            </button>
        </div>
    );
};

export default Marketing;